import Icon from '@components/icon/Icon';

interface SectionHeaderProps {
  title: string;
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

const SectionHeader = ({
  title,
  isOpen,
  onClick,
  className
}: SectionHeaderProps) => (
  <div
    className={`flex w-full justify-between py-6 ${className}`}
    role="presentation"
    onClick={onClick}
  >
    <p className="text-lg font-semibold">{title}</p>
    <Icon name="down-icon-dark" className={`${isOpen ? 'rotate-180' : ''}`} />
  </div>
);

export default SectionHeader;
